const packageSwiperThumbnails = new Swiper('.package-swiper-thumbnails', {

    slidesPerView: 5,
    watchSlidesProgress: true,
    loop:false,
    centerInsufficientSlides: true,
    spaceBetween: 12,

    breakpoints: {
        600: {
          slidesPerView: 6,
        },
        768: {
          slidesPerView: 7,
          spaceBetween: 16,
        },
        992: {
            slidesPerView: 5,
        },
        1200: {
          slidesPerView: 7,
        },
        1400: {
            slidesPerView: 8,
        },
    }

});

const packageSwiper = new Swiper('.package-swiper', {

    lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
    },

    loop:true,
    slidesPerView: 1,
    allowTouchMove: true,
    effect: 'fade',

    thumbs: {
        swiper: packageSwiperThumbnails,
    },

    pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
    },

    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    on: {
        click() {
            //console.log('index', this.clickedIndex);
            packageGalleryEnableFullscreen();
        },
    },
});

const packageGalleryContainer = document.getElementById('package-gallery-container');
const packageGalleryFullscreenClose = document.getElementById('package-gallery-fullscreen-close');

var packageGalleryIsFullscreen = false;

function packageGalleryEnableFullscreen() {
    if ( ! packageGalleryContainer.classList.contains('gallery-fullscreen')) {
        packageGalleryContainer.classList.add('gallery-fullscreen');
    }

    if ( ! document.body.classList.contains('scroll-disabled')) {
        document.body.classList.add('scroll-disabled');
    }
}

function packageGalleryDisableFullscreen() {
    if (packageGalleryContainer.classList.contains('gallery-fullscreen')) {
        packageGalleryContainer.classList.remove('gallery-fullscreen');
    }

    if ( document.body.classList.contains('scroll-disabled')) {
        document.body.classList.remove('scroll-disabled');
    }
}

packageGalleryFullscreenClose.onclick = function(e) {
    packageGalleryDisableFullscreen();
}

document.onkeydown = function (e) {
    if (e.key === "Escape") {
        packageGalleryDisableFullscreen();
    }
}